export const GetApplicationPreferences = {
    endpoint: "/users/@self/preferences/:application",
    pathParams: ["application"],
    method: "GET",
    request: undefined,
    response: undefined,
    paginated: false,
};
//# sourceMappingURL=GetApplicationPreferences.js.map